export default __webpack_public_path__ + "static/media/rick_mahomes.14fbee39.png";